import React from 'react';

export default (
  <svg width="17px" height="19px" viewBox="0 0 17 19">
    <g
      id="Policy-Mgmt-(Compiled)"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Policy-Management_Payment_Edit_02"
        transform="translate(-96.000000, -349.000000)"
        fill="#000000"
        fillRule="nonzero"
      >
        <g id="bank" transform="translate(96.000000, 349.000000)">
          <path
            d="M8.5,0 L0,4.47368421 L0,6.26315789 L17,6.26315789 L17,4.47368421 M12.5263158,8.05263158 L12.5263158,14.3157895 L15.2105263,14.3157895 L15.2105263,8.05263158 M0,18.7894737 L17,18.7894737 L17,16.1052632 L0,16.1052632 M7.15789474,8.05263158 L7.15789474,14.3157895 L9.84210526,14.3157895 L9.84210526,8.05263158 M1.78947368,8.05263158 L1.78947368,14.3157895 L4.47368421,14.3157895 L4.47368421,8.05263158 L1.78947368,8.05263158 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);
